import { Component } from '@angular/core';

@Component({
  selector: 'td-wb-panel-end',
  styles: [
    ':host { margin-left: auto}'
  ],
  template: '<ng-content />'
})
export class PanelEndComponent {}
